// extracted by mini-css-extract-plugin
module.exports = {"image__container":"styles_image__container__2OvMt"};